<div class="wrapper">
  <section id="area-breadcrumb" class="area-top">
    <div class="container">
      <nav class="breadcrumb">
        <ul>
          <li><a href="/"><strong>Home</strong></a></li>
          <span><i class="fas fa-chevron-right"></i></span>
          <li>Indique e Ganhe</li>
        </ul>
      </nav>
    </div>
  </section>

  <section id="indique-e-ganhe">
    <div class="container">
      <div class="columns">
        <div class="area-texto column is-10 is-offset-1">


          <img class="icon-montreal" src="assets/img/icon-montreal-indique.png" alt="montreal-viagens-logo-contato" />

          <h1 class="title">Indique e Ganhe</h1>
          <div *ngIf="!isMobile" class="menu-right">
            <ul class="nav-page">
              <li><a (click)="scroll('target_indicar_agora')">Indicar agora</a></li>
            </ul>
          </div>
          <p [class]="isMobile ? 'title-description' : ''">
            Viajar com desconto já é sensacional, não é mesmo? E se a gente te falar que, além de economizar,
            tem como você ganhar bônus em sua assinatura?
          </p>
          <br *ngIf="!isMobile">
          <div class="como-funciona">
            <img *ngIf="!isMobile" class="icon-compartilhe" src="assets/img/icon-compartilhe.png" alt="montreal-viagens-compartilhe"/>
            <p>
              Conheça nosso programa de indicação, sem pegadinha, sem burocracia e sem mistério.
              <br>
              <strong>Quanto mais você indica, mais você ganha!</strong>
            </p>

            <h4>Como funciona?</h4>
            <div class="columns">
              <p class="column">
                <span>1</span>
                <strong>Indique quantos amigos quiser!</strong>
                <br>
                <br *ngIf="isMobile">
                Preencha o formulário com os seus dados e os dos seus amigos. É bem rapidinho!
              </p>
              <p class="column">
                <span>2</span>
                <strong>Entraremos em contato</strong>
                <br>
                <br *ngIf="isMobile">
                Nosso time entrará em contato com você e com os seus amigos para explicar e tirar dúvidas,
                além de oferecer dicas de destinos e como aproveitar melhor suas viagens
                e os benefícios de sua assinatura.
              </p>
              <p class="column">
                <span>3</span>
                <strong>Isentaremos a taxa de adesão</strong>
                <br>
                <br *ngIf="isMobile">
                Seu amigo já começará economizando: Taxa de Adesão grátis para todo mundo!
              </p>
              <p class="column">
                <span>4</span>
                <strong>Vantagens para todo mundo!</strong>
                <br>
                <br *ngIf="isMobile">
                Bônus para você*! Eles serão utilizados como abatimento em seu Clube de Hospedagem no mês
                seguinte ao pagamento de 4 parcelas dos planos de cada um dos seus amigos indicados.
              </p>
            </div>
            <p class="juridico">
              *O valor máximo de recebimento do bônus está limitado ao plano Ideal de 7 diárias, duplo ou triplo,
              dependendo da modalidade escolhida por seu amigo indicado.
            </p>
          </div>

          <div class="local-scroll-indique" id='target_indicar_agora'></div>

          <div class="columns content-indique">
            <div class="column" *ngIf="!isMobile">
              <p><strong>Confira os Valores que você irá Ganhar!</strong></p>

              <p>Viajar é sempre divertido, mas viajar com os amigos é melhor ainda. Dá uma olhadinha nos valores que serão abatidos da sua assinatura:</p>

              <img class="image-compartilhe" src="assets/img/tabela-completo-2024.jpeg" />
              <img class="image-compartilhe" src="assets/img/tabela-ideal-2024.jpeg" />
<!--              <img class="image-compartilhe" src="assets/img/img-indique-amigos.png" />-->


            </div>

            <div class="column area-form">
              <ng-container *ngTemplateOutlet="forms"></ng-container>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>

  <app-new-footer></app-new-footer>
</div>

<ng-template #forms>
  <form id="form-indique" class="sample-form" method="post" target="_top" [formGroup]="form" (submit)="onSave()">
    <h4>Indicar amigos</h4>
    <p class="form-subtitle"><strong style="text-decoration: underline">Agora preencha os dados do seu indicado.</strong></p>

    <div class="field control-input indique-amigos" tabindex="1">
      <label for="name">Nome do cliente indicante</label>
      <input name="name"
             id="name"
             type="text"
             formControlName="name"
             placeholder="Nome"
             required
             (focusout)="validate('name', 'SPECIAL_CHARACTER')"
             [class]="fieldCssClass(form, 'name')">
      <span class="campo-erro" *ngIf="showError('name')">{{getErrorMessage('name')}}</span>
    </div>

    <div class="field control-input indique-amigos" tabindex="1">
      <label for="email">Email do cliente indicante</label>
      <input name="email"
             id="email"
             type="email"
             placeholder="E-mail"
             required
             formControlName="email"
             (focusout)="validate('email', 'EMAIL')"
             [class]="fieldCssClass(form, 'email')">
      <span class="campo-erro" *ngIf="showError('email')">{{getErrorMessage('email')}}</span>

    </div>

    <div class="field control-input indique-amigos" tabindex="1">
      <label for="cf_telefone_do_indicante">Telefone do cliente indicante</label>
      <input name="cf_telefone_do_indicante"
             type="text"
             id="cf_telefone_do_indicante"
             formControlName="cf_telefone_do_indicante"
             placeholder="Celular"
             required
             maxlength="11"
             minlength="11"
             (focusout)="validate('cf_telefone_do_indicante', 'SPECIAL_CHARACTER')"
             [class]="fieldCssClass(form, 'cf_telefone_do_indicante')">
      <span class="campo-erro" *ngIf="showError('cf_telefone_do_indicante')">{{getErrorMessage('cf_telefone_do_indicante')}}</span>
    </div>

    <div class="field control-input indique-amigos" tabindex="1">
      <label for="cf_cpf_indicante">CPF do cliente indicante</label>
      <input mask="000.000.000-00"
             name="cf_cpf_indicante"
             id="cf_cpf_indicante"
             type="text"
             formControlName="cf_cpf_indicante"
             placeholder="CPF"
             required
             [class]="fieldCssClass(form, 'cf_cpf_indicante')">
      <span class="campo-erro" *ngIf="showError('cf_cpf_indicante')">{{getErrorMessage('cf_cpf_indicante')}}</span>
    </div>

    <p class="text-center"><strong style="text-decoration: underline">Agora preencha os dados dos seus amigos:</strong></p>


    <div class="field control-input indique-amigos amigo-1" tabindex="1">
      <label for="cf_nome_do_indicado_1">Nome do amigo indicado</label>
      <input formControlName="cf_nome_do_indicado_1"
             name="cf_nome_do_indicado_1"
             id="cf_nome_do_indicado_1"
             type="text"
             placeholder="Nome"
             required
             (focusout)="validate('cf_nome_do_indicado_1', 'SPECIAL_CHARACTER')"
             [class]="fieldCssClass(form, 'cf_nome_do_indicado_1')">
      <span class="campo-erro" *ngIf="showError('cf_nome_do_indicado_1')">{{getErrorMessage('cf_nome_do_indicado_1')}}</span>
    </div>

    <div class="field control-input indique-amigos amigo-1" tabindex="1">
      <label for="cf_telefone_do_indicado_1">Telefone do amigo indicado</label>
      <input formControlName="cf_telefone_do_indicado_1"
             id="cf_telefone_do_indicado_1"
             name="cf_telefone_do_indicado_1"
             type="text"
             placeholder="Celular"
             required
             maxlength="11"
             minlength="11"
             (focusout)="validate('cf_telefone_do_indicado_1', 'SPECIAL_CHARACTER')"
             [class]="fieldCssClass(form, 'cf_telefone_do_indicado_1')">
      <span class="campo-erro" *ngIf="showError('cf_telefone_do_indicado_1')">{{getErrorMessage('cf_telefone_do_indicado_1')}}</span>
    </div>
    <div class="field control-input indique-amigos amigo-1" tabindex="1">
      <label for="cf_telefone_do_indicado_1">Email do amigo indicado</label>
      <input name="cf_email_do_indicado_1"
             id="cf_email_do_indicado_1"
             type="email"
             placeholder="E-mail"
             required
             formControlName="cf_email_do_indicado_1"
             (focusout)="validate('cf_email_do_indicado_1', 'EMAIL')"
             [class]="fieldCssClass(form, 'cf_email_do_indicado_1')">
      <span class="campo-erro" *ngIf="showError('cf_email_do_indicado_1')">{{getErrorMessage('cf_email_do_indicado_1')}}</span>
    </div>

<!--    <div class="hidden-amigo-2">-->
<!--      <input id="collapsible-2" class="toggle" type="checkbox">-->
<!--      <label for="collapsible-2" class="lbl-toggle"><i class="far fa-plus-circle"></i><small>Adicionar outro-->
<!--        indicado</small></label>-->
<!--      <div class="collapsible-content">-->
<!--        <p><strong>Amigo Indicado 2</strong></p>-->
<!--        <div class="content-inner">-->
<!--          <div class="field control-input indique-amigos" tabindex="1">-->
<!--            <label for="cf_nome_do_indicado_2">Nome do amigo indicado</label>-->
<!--            <input formControlName="cf_nome_do_indicado_2"-->
<!--                   name="cf_nome_do_indicado_2"-->
<!--                   id="cf_nome_do_indicado_2"-->
<!--                   type="text"-->
<!--                   placeholder="Nome"-->
<!--                   (focusout)="validate('cf_nome_do_indicado_2', 'SPECIAL_CHARACTER')"-->
<!--                   [class]="fieldCssClass(form, 'cf_nome_do_indicado_2')">-->
<!--            <span class="campo-erro" *ngIf="showError('cf_nome_do_indicado_2')">{{getErrorMessage('cf_nome_do_indicado_2')}}</span>-->
<!--          </div>-->
<!--          <div class="field control-input indique-amigos" tabindex="1">-->
<!--            <label for="cf_telefone_do_indicado_2">Telefone do amigo indicado</label>-->
<!--            <input formControlName="cf_telefone_do_indicado_2"-->
<!--                   mask="00000000000"-->
<!--                   id="cf_telefone_do_indicado_2"-->
<!--                   name="cf_telefone_do_indicado_2"-->
<!--                   type="text"-->
<!--                   placeholder="Celular"-->
<!--                   maxlength="11"-->
<!--                   minlength="11"-->
<!--                   (focusout)="validate('cf_telefone_do_indicado_2', 'SPECIAL_CHARACTER')"-->
<!--                   [class]="fieldCssClass(form, 'cf_telefone_do_indicado_2')">-->
<!--            <span class="campo-erro" *ngIf="showError('cf_telefone_do_indicado_2')">{{getErrorMessage('cf_telefone_do_indicado_2')}}</span>-->
<!--          </div>-->
<!--        </div>-->


<!--        <div class="hidden-amigo-3">-->
<!--          <input id="collapsible-3" class="toggle" type="checkbox">-->
<!--          <label for="collapsible-3" class="lbl-toggle">-->
<!--            <i class="far fa-plus-circle"></i>-->
<!--            <small>Adicionar outro indicado</small>-->
<!--          </label>-->
<!--          <div class="collapsible-content">-->
<!--            <p><strong>Amigo Indicado 3</strong></p>-->
<!--            <div class="content-inner">-->
<!--              <div class="field control-input indique-amigos" tabindex="1">-->
<!--                <label for="cf_nome_do_indicado_3">Nome do amigo indicado</label>-->
<!--                <input formControlName="cf_nome_do_indicado_3"-->
<!--                       name="cf_nome_do_indicado_3"-->
<!--                       id="cf_nome_do_indicado_3"-->
<!--                       type="text"-->
<!--                       placeholder="Nome"-->
<!--                       (focusout)="validate('cf_nome_do_indicado_3', 'SPECIAL_CHARACTER')"-->
<!--                       [class]="fieldCssClass(form, 'cf_nome_do_indicado_3')">-->
<!--                <span class="campo-erro" *ngIf="showError('cf_nome_do_indicado_3')">{{getErrorMessage('cf_nome_do_indicado_3')}}</span>-->
<!--              </div>-->
<!--              <div class="field control-input indique-amigos" tabindex="1">-->
<!--                <label for="cf_telefone_do_indicado_3">Telefone do amigo indicado</label>-->
<!--                <input formControlName="cf_telefone_do_indicado_3"-->
<!--                       mask="00000000000"-->
<!--                       name="cf_telefone_do_indicado_3"-->
<!--                       id="cf_telefone_do_indicado_3"-->
<!--                       type="text"-->
<!--                       placeholder="Celular"-->
<!--                       maxlength="11"-->
<!--                       minlength="11"-->
<!--                       (focusout)="validate('cf_telefone_do_indicado_3', 'SPECIAL_CHARACTER')"-->
<!--                       [class]="fieldCssClass(form, 'cf_telefone_do_indicado_3')">-->
<!--                <span class="campo-erro" *ngIf="showError('cf_telefone_do_indicado_3')">{{getErrorMessage('cf_telefone_do_indicado_3')}}</span>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="hidden-amigo-4">-->
<!--              <input id="collapsible-4" class="toggle" type="checkbox">-->
<!--              <label for="collapsible-4" class="lbl-toggle"><i-->
<!--                      class="far fa-plus-circle"></i><small>Adicionar outro indicado</small></label>-->
<!--              <div class="collapsible-content">-->
<!--                <p><strong>Amigo Indicado 4</strong></p>-->
<!--                <div class="content-inner">-->
<!--                  <div class="field control-input indique-amigos" tabindex="1">-->
<!--                    <label for="cf_nome_do_indicado_4">Nome do amigo indicado</label>-->
<!--                    <input formControlName="cf_nome_do_indicado_4"-->
<!--                           name="cf_nome_do_indicado_4"-->
<!--                           id="cf_nome_do_indicado_4"-->
<!--                           type="text"-->
<!--                           placeholder="Nome"-->
<!--                           (focusout)="validate('cf_nome_do_indicado_4', 'SPECIAL_CHARACTER')"-->
<!--                           [class]="fieldCssClass(form, 'cf_nome_do_indicado_4')">-->
<!--                    <span class="campo-erro" *ngIf="showError('cf_nome_do_indicado_4')">{{getErrorMessage('cf_nome_do_indicado_4')}}</span>-->
<!--                  </div>-->
<!--                  <div class="field control-input indique-amigos" tabindex="1">-->
<!--                    <label for="cf_telefone_do_indicado_4">Telefone do amigo indicado</label>-->
<!--                    <input formControlName="cf_telefone_do_indicado_4"-->
<!--                           mask="00000000000"-->
<!--                           name="cf_telefone_do_indicado_4"-->
<!--                           id="cf_telefone_do_indicado_4"-->
<!--                           type="text"-->
<!--                           placeholder="Celular"-->
<!--                           (focusout)="validate('cf_telefone_do_indicado_4', 'SPECIAL_CHARACTER')"-->
<!--                           [class]="fieldCssClass(form, 'cf_telefone_do_indicado_4')">-->
<!--                    <span class="campo-erro" *ngIf="showError('cf_telefone_do_indicado_4')">{{getErrorMessage('cf_telefone_do_indicado_4')}}</span>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="hidden-amigo-5">-->
<!--                  <input id="collapsible-5" class="toggle" type="checkbox">-->
<!--                  <label for="collapsible-5" class="lbl-toggle"><i-->
<!--                          class="far fa-plus-circle"></i><small>Adicionar outro indicado</small></label>-->
<!--                  <div class="collapsible-content">-->
<!--                    <p><strong>Amigo Indicado 5</strong></p>-->
<!--                    <div class="content-inner">-->
<!--                      <div class="field control-input indique-amigos" tabindex="1">-->
<!--                        <label for="cf_nome_do_indicado_5">Nome do amigo indicado</label>-->
<!--                        <input formControlName="cf_nome_do_indicado_5"-->
<!--                               name="cf_nome_do_indicado_5"-->
<!--                               id="cf_nome_do_indicado_5"-->
<!--                               type="text"-->
<!--                               placeholder="Nome"-->
<!--                               (focusout)="validate('cf_nome_do_indicado_5', 'SPECIAL_CHARACTER')"-->
<!--                               [class]="fieldCssClass(form, 'cf_nome_do_indicado_5')">-->
<!--                        <span class="campo-erro" *ngIf="showError('cf_nome_do_indicado_5')">{{getErrorMessage('cf_nome_do_indicado_5')}}</span>-->
<!--                      </div>-->
<!--                      <div class="field control-input indique-amigos" tabindex="1">-->
<!--                        <label for="cf_telefone_do_indicado_5">Telefone do amigo indicado</label>-->
<!--                        <input formControlName="cf_telefone_do_indicado_5"-->
<!--                               mask="00000000000"-->
<!--                               name="cf_telefone_do_indicado_5"-->
<!--                               id="cf_telefone_do_indicado_5"-->
<!--                               type="text"-->
<!--                               placeholder="Celular"-->
<!--                               maxlength="11"-->
<!--                               minlength="11"-->
<!--                               (focusout)="validate('cf_telefone_do_indicado_5', 'SPECIAL_CHARACTER')"-->
<!--                               [class]="fieldCssClass(form, 'cf_telefone_do_indicado_5')">-->
<!--                        <span class="campo-erro" *ngIf="showError('cf_telefone_do_indicado_5')">{{getErrorMessage('cf_telefone_do_indicado_5')}}</span>-->
<!--                      </div>-->
<!--                    </div>-->

<!--                    <div class="hidden-amigo-6">-->
<!--                      <input id="collapsible-6" class="toggle" type="checkbox">-->
<!--                      <label for="collapsible-6" class="lbl-toggle"><i-->
<!--                              class="far fa-plus-circle"></i><small>Adicionar outro indicado</small></label>-->
<!--                      <div class="collapsible-content">-->
<!--                        <p><strong>Amigo Indicado 6</strong></p>-->
<!--                        <div class="content-inner">-->
<!--                          <div class="field control-input indique-amigos" tabindex="1">-->
<!--                            <label for="cf_nome_do_indicado_6">Nome do amigo indicado</label>-->
<!--                            <input formControlName="cf_nome_do_indicado_6"-->
<!--                                   name="cf_nome_do_indicado_6"-->
<!--                                   id="cf_nome_do_indicado_6"-->
<!--                                   type="text"-->
<!--                                   placeholder="Nome"-->
<!--                                   (focusout)="validate('cf_nome_do_indicado_6', 'SPECIAL_CHARACTER')"-->
<!--                                   [class]="fieldCssClass(form, 'cf_nome_do_indicado_6')">-->
<!--                            <span class="campo-erro" *ngIf="showError('cf_nome_do_indicado_6')">{{getErrorMessage('cf_nome_do_indicado_6')}}</span>-->
<!--                          </div>-->
<!--                          <div class="field control-input indique-amigos" tabindex="1">-->
<!--                            <label for="cf_telefone_do_indicado_6">Telefone do amigo indicado</label>-->
<!--                            <input formControlName="cf_telefone_do_indicado_6"-->
<!--                                   mask="00000000000"-->
<!--                                   name="cf_telefone_do_indicado_6"-->
<!--                                   id="cf_telefone_do_indicado_6"-->
<!--                                   type="text"-->
<!--                                   placeholder="Celular"-->
<!--                                   maxlength="11"-->
<!--                                   minlength="11"-->
<!--                                   (focusout)="validate('cf_telefone_do_indicado_6', 'SPECIAL_CHARACTER')"-->
<!--                                   [class]="fieldCssClass(form, 'cf_telefone_do_indicado_6')">-->
<!--                            <span class="campo-erro" *ngIf="showError('cf_telefone_do_indicado_6')">{{getErrorMessage('cf_telefone_do_indicado_6')}}</span>-->
<!--                          </div>-->
<!--                        </div>-->

<!--                        <div class="hidden-amigo-7">-->
<!--                          <input id="collapsible-7" class="toggle" type="checkbox">-->
<!--                          <label for="collapsible-7" class="lbl-toggle"><i-->
<!--                                  class="far fa-plus-circle"></i><small>Adicionar outro indicado</small></label>-->
<!--                          <div class="collapsible-content">-->
<!--                            <p><strong>Amigo Indicado 7</strong></p>-->
<!--                            <div class="content-inner">-->
<!--                              <div class="field control-input indique-amigos" tabindex="1">-->
<!--                                <label for="cf_nome_do_indicado_7">Nome do amigo indicado</label>-->
<!--                                <input formControlName="cf_nome_do_indicado_7"-->
<!--                                       name="cf_nome_do_indicado_7"-->
<!--                                       id="cf_nome_do_indicado_7"-->
<!--                                       type="text"-->
<!--                                       placeholder="Nome"-->
<!--                                       (focusout)="validate('cf_nome_do_indicado_7', 'SPECIAL_CHARACTER')"-->
<!--                                       [class]="fieldCssClass(form, 'cf_nome_do_indicado_7')">-->
<!--                                <span class="campo-erro" *ngIf="showError('cf_nome_do_indicado_7')">{{getErrorMessage('cf_nome_do_indicado_7')}}</span>-->
<!--                              </div>-->
<!--                              <div class="field control-input indique-amigos" tabindex="1">-->
<!--                                <label for="cf_telefone_do_indicado_7">Telefone do amigo indicado</label>-->
<!--                                <input formControlName="cf_telefone_do_indicado_7"-->
<!--                                       mask="00000000000"-->
<!--                                       name="cf_telefone_do_indicado_7"-->
<!--                                       id="cf_telefone_do_indicado_7"-->
<!--                                       type="text"-->
<!--                                       placeholder="Celular"-->
<!--                                       maxlength="11"-->
<!--                                       minlength="11"-->
<!--                                       (focusout)="validate('cf_telefone_do_indicado_7', 'SPECIAL_CHARACTER')"-->
<!--                                       [class]="fieldCssClass(form, 'cf_telefone_do_indicado_7')">-->
<!--                                <span class="campo-erro" *ngIf="showError('cf_telefone_do_indicado_7')">{{getErrorMessage('cf_telefone_do_indicado_7')}}</span>-->
<!--                              </div>-->
<!--                            </div>-->

<!--                            <div class="hidden-amigo-8">-->
<!--                              <input id="collapsible-8" class="toggle" type="checkbox">-->
<!--                              <label for="collapsible-8" class="lbl-toggle"><i-->
<!--                                      class="far fa-plus-circle"></i><small>Adicionar outro-->
<!--                                indicado</small></label>-->
<!--                              <div class="collapsible-content">-->
<!--                                <p><strong>Amigo Indicado 8</strong></p>-->
<!--                                <div class="content-inner">-->
<!--                                  <div class="field control-input indique-amigos" tabindex="1">-->
<!--                                    <label for="cf_nome_do_indicado_8">Nome do amigo indicado</label>-->
<!--                                    <input formControlName="cf_nome_do_indicado_8"-->
<!--                                           name="cf_nome_do_indicado_8"-->
<!--                                           id="cf_nome_do_indicado_8"-->
<!--                                           type="text"-->
<!--                                           placeholder="Nome"-->
<!--                                           (focusout)="validate('cf_nome_do_indicado_8', 'SPECIAL_CHARACTER')"-->
<!--                                           [class]="fieldCssClass(form, 'cf_nome_do_indicado_8')">-->
<!--                                    <span class="campo-erro" *ngIf="showError('cf_nome_do_indicado_8')">{{getErrorMessage('cf_nome_do_indicado_8')}}</span>-->
<!--                                  </div>-->
<!--                                  <div class="field control-input indique-amigos" tabindex="1">-->
<!--                                    <label for="cf_telefone_do_indicado_8">Telefone do amigo indicado</label>-->
<!--                                    <input formControlName="cf_telefone_do_indicado_8"-->
<!--                                           mask="00000000000"-->
<!--                                           id="cf_telefone_do_indicado_8"-->
<!--                                           name="cf_telefone_do_indicado_8"-->
<!--                                           type="text"-->
<!--                                           placeholder="Celular"-->
<!--                                           maxlength="11"-->
<!--                                           minlength="11"-->
<!--                                           (focusout)="validate('cf_telefone_do_indicado_8', 'SPECIAL_CHARACTER')"-->
<!--                                           [class]="fieldCssClass(form, 'cf_telefone_do_indicado_8')">-->
<!--                                    <span class="campo-erro" *ngIf="showError('cf_telefone_do_indicado_8')">{{getErrorMessage('cf_telefone_do_indicado_8')}}</span>-->
<!--                                  </div>-->
<!--                                </div>-->

<!--                                <div class="hidden-amigo-9">-->
<!--                                  <input id="collapsible-9" class="toggle" type="checkbox">-->
<!--                                  <label for="collapsible-9" class="lbl-toggle"><i-->
<!--                                          class="far fa-plus-circle"></i><small>Adicionar outro-->
<!--                                    indicado</small></label>-->
<!--                                  <div class="collapsible-content">-->
<!--                                    <p><strong>Amigo Indicado 9</strong></p>-->
<!--                                    <div class="content-inner">-->
<!--                                      <div class="field control-input indique-amigos" tabindex="1">-->
<!--                                        <label for="cf_nome_do_indicado_9">Nome do amigo indicado</label>-->
<!--                                        <input formControlName="cf_nome_do_indicado_9"-->
<!--                                               name="cf_nome_do_indicado_9"-->
<!--                                               id="cf_nome_do_indicado_9"-->
<!--                                               type="text"-->
<!--                                               placeholder="Nome"-->
<!--                                               (focusout)="validate('cf_nome_do_indicado_9', 'SPECIAL_CHARACTER')"-->
<!--                                               [class]="fieldCssClass(form, 'cf_nome_do_indicado_9')">-->
<!--                                        <span class="campo-erro" *ngIf="showError('cf_nome_do_indicado_9')">{{getErrorMessage('cf_nome_do_indicado_9')}}</span>-->
<!--                                      </div>-->
<!--                                      <div class="field control-input indique-amigos" tabindex="1">-->
<!--                                        <label for="cf_telefone_do_indicado_9">Telefone do amigo indicado</label>-->
<!--                                        <input formControlName="cf_telefone_do_indicado_9"-->
<!--                                               mask="00000000000"-->
<!--                                               id="cf_telefone_do_indicado_9"-->
<!--                                               name="cf_telefone_do_indicado_9"-->
<!--                                               type="text"-->
<!--                                               placeholder="Celular"-->
<!--                                               maxlength="11"-->
<!--                                               minlength="11"-->
<!--                                               (focusout)="validate('cf_telefone_do_indicado_9', 'SPECIAL_CHARACTER')"-->
<!--                                               [class]="fieldCssClass(form, 'cf_telefone_do_indicado_9')">-->
<!--                                        <span class="campo-erro" *ngIf="showError('cf_telefone_do_indicado_9')">{{getErrorMessage('cf_telefone_do_indicado_9')}}</span>-->
<!--                                      </div>-->
<!--                                    </div>-->

<!--                                    <div class="hidden-amigo-10">-->
<!--                                      <input id="collapsible-10" class="toggle" type="checkbox">-->
<!--                                      <label for="collapsible-10" class="lbl-toggle"><i-->
<!--                                              class="far fa-plus-circle"></i><small>Adicionar outro-->
<!--                                        indicado</small></label>-->
<!--                                      <div class="collapsible-content">-->
<!--                                        <p><strong>Amigo Indicado 10</strong></p>-->
<!--                                        <div class="content-inner">-->
<!--                                          <div class="field control-input indique-amigos" tabindex="1">-->
<!--                                            <label for="cf_nome_do_indicado_10">Nome do amigo indicado</label>-->
<!--                                            <input formControlName="cf_nome_do_indicado_10"-->
<!--                                                   name="cf_nome_do_indicado_10"-->
<!--                                                   id="cf_nome_do_indicado_10"-->
<!--                                                   type="text"-->
<!--                                                   placeholder="Nome"-->
<!--                                                   (focusout)="validate('cf_nome_do_indicado_10', 'SPECIAL_CHARACTER')"-->
<!--                                                   [class]="fieldCssClass(form, 'cf_nome_do_indicado_10')">-->
<!--                                            <span class="campo-erro" *ngIf="showError('cf_nome_do_indicado_10')">{{getErrorMessage('cf_nome_do_indicado_10')}}</span>-->
<!--                                          </div>-->
<!--                                          <div class="field control-input indique-amigos" tabindex="1">-->
<!--                                            <label for="cf_telefone_do_indicado_10">Telefone do amigo indicado</label>-->
<!--                                            <input id="cf_telefone_do_indicado_10"-->
<!--                                                   name="cf_telefone_do_indicado_10"-->
<!--                                                   type="text"-->
<!--                                                   placeholder="Celular"-->
<!--                                                   maxlength="11"-->
<!--                                                   minlength="11"-->
<!--                                                   formControlName="cf_telefone_do_indicado_10"-->
<!--                                                   (focusout)="validate('cf_telefone_do_indicado_10', 'SPECIAL_CHARACTER')"-->
<!--                                                   [class]="fieldCssClass(form, 'cf_telefone_do_indicado_10')">-->
<!--                                            <span class="campo-erro" *ngIf="showError('cf_telefone_do_indicado_10')">{{getErrorMessage('cf_telefone_do_indicado_10')}}</span>-->
<!--                                          </div>-->
<!--                                        </div>-->
<!--                                      </div>-->
<!--                                    </div>-->

<!--                                  </div>-->
<!--                                </div>-->

<!--                              </div>-->
<!--                            </div>-->

<!--                          </div>-->
<!--                        </div>-->

<!--                      </div>-->
<!--                    </div>-->

<!--                  </div>-->
<!--                </div>-->

<!--              </div>-->
<!--            </div>-->

<!--          </div>-->
<!--        </div>-->

<!--      </div>-->
<!--    </div>-->
    <div style="padding-top: 1.2em; padding-bottom: 1.2em;">
      <app-termo-uso [type]="'indique-e-ganhe'"
                     [link]="'assets/pdf/2019-Indique-Amigos.pdf'"
                     (termoDeUsoAceitoEmit)="termoDeUsoAceitoEmit($event)"></app-termo-uso>
    </div>
    <button class="btn-verde"
            id="button-indique-bonus"
            [disabled]="!termoDeUsoAceito"
            [class]="!termoDeUsoAceito ? 'btn-desabilitado' : 'btn-verde'"
            type="submit">INDICAR AGORA</button>

<!--    <span class="description-footer">-->
<!--                  Confira o regulamento do programa de indicação-->
<!--                  <a href="https://www.viagensmontreal.com/design/Regulamento_Promo/2019-Indique-Amigos.pdf"-->
<!--                     target="_blank"-->
<!--                     style="color: #0f81cc; text-decoration: underline">-->
<!--                    aqui-->
<!--                  </a>.-->
<!--                </span>-->


    <div submit-error>
      <template type="amp-mustache">
        <p class="alert-error">
        </p>
      </template>
    </div>

    <div submit-success id="header-internas"
         [class]="mostrarMensagemSucesso ? 'modal finish-step is-active' : 'modal finish-step'">


      <div class="area-sucesso text-center">
        <div class="painel area-rounded area-item-obrigado">
          <br>
          <div class="close">
            <button class="btn btn-close" (click)="mostrarMensagemSucesso = false">X</button>
          </div>
          <h2 class="quase-la">MUITO OBRIGADO!</h2>
          <strong>
            Em breve, um de nossos especialistas entrará
            <br>
            em contato com você e seus amigos!
          </strong>
          <br>
          <br>
          Enquanto isso, que tal continuar navegando em nosso site,
          <br>
          <a href="/hoteis" class="btn">
            <u>conhecer nossos hotéis</u>
          </a>
          e já começar a planejar sua próxima viagem?
          <br>
          <br>
          <a class="btn btn-submit" href="/hoteis">DESCOBRIR HOTÉIS E DESTINOS</a>
          <br>
        </div>
      </div>

    </div>
  </form>
</ng-template>
